import { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import type { GiftBranding } from '@pickonegift/shared';

export default function Success() {
    const location = useLocation();
    const state = location.state as { chosenItem?: string; branding?: GiftBranding } | null;

    useEffect(() => {
        if (state?.branding?.primaryColor) {
            const root = document.documentElement;
            root.style.setProperty('--color-primary', state.branding.primaryColor);
            root.style.setProperty(
                '--gradient-primary',
                `linear-gradient(135deg, ${state.branding.primaryColor} 0%, rgba(255,255,255,0.2) 100%)`
            );
        }

        return () => {
            const root = document.documentElement;
            root.style.removeProperty('--color-primary');
            root.style.removeProperty('--gradient-primary');
        };
    }, [state?.branding]);

    const renderHeader = () => {
        if (state?.branding) {
            return (
                <header className="header">
                    <div className="container header-inner" style={{ justifyContent: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <img
                                src={state.branding.logoUrl}
                                alt={state.branding.companyName}
                                style={{ height: '40px', objectFit: 'contain', borderRadius: '4px' }}
                            />
                            <span style={{ fontSize: '1.2rem', fontWeight: 600 }}>{state.branding.companyName}</span>
                        </div>
                    </div>
                </header>
            );
        }
        return <Header />;
    };

    return (
        <div className="page">
            {renderHeader()}
            <div className="success-container fade-in">
                <div className="success-icon">🎉</div>
                <h1>Wybór zapisany!</h1>
                <p className="text-muted mt-md" style={{ maxWidth: 500, margin: '16px auto 0' }}>
                    {state?.chosenItem ? (
                        <>
                            Wybrałeś/aś prezent <strong>&ldquo;{state.chosenItem}&rdquo;</strong>.
                        </>
                    ) : (
                        'Twój wybór został pomyślnie zapisany.'
                    )}
                </p>
                <p className="text-muted mt-sm" style={{ maxWidth: 500, margin: '8px auto 0' }}>
                    Osoba, która stworzyła listę, otrzyma powiadomienie e-mail z Twoim wyborem
                    oraz danymi do wysyłki. Dane wysyłkowe nie są przechowywane na naszych serwerach.
                </p>
                <div className="mt-xl">
                    <Link to="/" className="btn btn-primary btn-lg">
                        🏠 Strona główna
                    </Link>
                </div>
            </div>
            <Footer />
        </div>
    );
}
